import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { ActionFromPayloadMap } from '../config/types';
import UserReducer from '../reducers/users';

type User = {
  email: string;
  name: string;
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
  sso: boolean;
  id: string;
  global_meta: Record<string, unknown>;
  project_meta: ProjectMeta[];
};

type ProjectMeta = {
  project: string;
  tenant: string;
  dismissed_announcement_ids: string[];
};

export type UserStateType = {
  user: User | null;
  isFetchingUser: boolean
};

export type UserActionPayloadMap = {
  SET_USER: UserStateType['user'];
  SET_FETCHING_USER: boolean;
};

export type UserAction = ActionFromPayloadMap<UserActionPayloadMap>;

const initialState: UserStateType = {
  user: null,
  isFetchingUser: false,
};

export const UserContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<UserAction>,
});

export const useUser = (): [UserStateType, React.Dispatch<UserAction>] => {
  const { state, dispatch } = useContext(UserContext);
  return [state, dispatch];
};

export const UserProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(UserReducer, initialState);

  return (
    <UserContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
